import { motion } from "framer-motion";
import { IMAGES } from "@/lib/wedding-data";

export default function Invitation() {
  return (
    <section
      id="invitation"
      data-testid="invitation-section"
      className="scroll-mt-24 py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="md:col-span-5"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-6">
            The Invitation
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#1A1A1A] leading-[1.05]">
            Two hearts, <br />
            <span className="italic text-[#5D171E]">one celebration</span>
          </h2>
          <div className="mt-12 hidden md:block">
            <div className="gold-frame h-96 w-72 overflow-hidden rounded-t-[144px] rounded-b-2xl border border-[#D4AF37]/40">
              <img
                src={IMAGES.ethnic}
                alt="Vishi and Piyush in evening ethnic wear"
                loading="lazy"
                data-testid="invitation-photo"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="md:col-span-7"
        >
          <div className="gold-frame rounded-t-[100px] rounded-b-2xl bg-white/60 border border-[#D4AF37]/40 px-8 py-14 md:px-16 text-center">
            <p className="text-xs uppercase tracking-[0.3em] text-[#5D171E]/70">
              Together with their families
            </p>
            <p className="mt-8 font-serif text-3xl md:text-4xl text-[#5D171E]">
              Vishi <span className="italic text-[#D4AF37]">&</span> Piyush
            </p>
            <div className="my-8 flex items-center justify-center gap-4">
              <span className="h-px w-16 bg-[#D4AF37]/60" />
              <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
              <span className="h-px w-16 bg-[#D4AF37]/60" />
            </div>
            <p className="text-base text-[#1A1A1A]/75 leading-relaxed max-w-md mx-auto">
              request the honour of your presence as they exchange vows and step
              into forever, surrounded by the people they love most.
            </p>
            <p className="mt-8 text-sm uppercase tracking-[0.2em] text-[#1A1A1A]/60">
              Sunday · January 24, 2027 · Lelux Resort, Gurgaon
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
